<script setup>
import { computed } from "vue"
import { usePage } from "@inertiajs/vue3"
import Button from "@/components/buttons/Button.vue"
import Modal from "@/components/feedback/Modal.vue"
import { useConfirmState } from "@/composables/useConfirm"

const { state, resolve } = useConfirmState()
const ui = computed(() => usePage().props.ui ?? {})

const cancelLabel = computed(() => state.cancelLabel ?? ui.value.cancel)

const onConfirm = () => resolve(true)
const onCancel = () => resolve(false)
</script>

<template>
  <Modal
    :open="state.open"
    :title="state.title"
    size="sm"
    @update:open="(value) => value || onCancel()"
  >
    <p class="text-sm text-black">{{ state.message }}</p>

    <template #footer>
      <Button variant="ghost" @click="onCancel">{{ cancelLabel }}</Button>
      <Button :variant="state.variant" @click="onConfirm">{{ state.confirmLabel }}</Button>
    </template>
  </Modal>
</template>
